import el from "@cypherpotato/el";
import { joinObjects } from "../util";
import { Icon } from "./icon";

export function Expander(title, ...contents) {

    const obj = joinObjects(...contents);
    const grip = el.state.create("arrow-down-s-line");

    return el("details.expander",
        el("summary",
            el.state.listening([grip], () =>
                Icon(grip.value)
            ),
            title,
        ),
        el("div", ...contents),
        {
            onToggle(event) {
                grip.value = event.target.open ? "arrow-up-s-line" : "arrow-down-s-line";
            },
            open: obj.open
        }
    )
}